'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

require('select2/select2.css');

require('select2-bootstrap-css/select2-bootstrap.css');

var _factoriesScSelectParser = require('./factories/scSelectParser');

var _factoriesScSelectParser2 = _interopRequireDefault(_factoriesScSelectParser);

var _directivesScSelect = require('./directives/scSelect');

var _directivesScSelect2 = _interopRequireDefault(_directivesScSelect);

var _directivesScOptions = require('./directives/scOptions');

var _directivesScOptions2 = _interopRequireDefault(_directivesScOptions);

var _directivesScSelectPaginator = require('./directives/scSelectPaginator');

var _directivesScSelectPaginator2 = _interopRequireDefault(_directivesScSelectPaginator);

exports['default'] = _angular2['default'].module('sc.select', ['ngSanitize', 'ui.select']).factory('scSelectParser', _factoriesScSelectParser2['default']).directive('scSelect', _directivesScSelect2['default']).directive('scOptions', _directivesScOptions2['default']).directive('scSelectPaginator', _directivesScSelectPaginator2['default']).run( /*@ngInject*/function ($templateCache) {

  var multiTemplateName = 'select2/select-multiple.tpl.html';
  var multiTemplate = _angular2['default'].element('<div>' + $templateCache.get(multiTemplateName) + '</div>');
  multiTemplate.find('ul').next().prepend(_angular2['default'].element('<sc-select-paginator></sc-select-paginator>'));
  multiTemplate.find('input').attr('ng-disabled', '$select.disabled || ($select.searchEnabled === false && $select.open)');
  $templateCache.put(multiTemplateName, multiTemplate.html());
}).run( /*@ngInject*/function ($templateCache) {

  var singleTemplateName = 'select2/select.tpl.html';
  var singleTemplate = _angular2['default'].element('<div>' + $templateCache.get(singleTemplateName) + '</div>');
  singleTemplate.find('input').parent().append(_angular2['default'].element('<sc-select-paginator></sc-select-paginator>'));
  $templateCache.put(singleTemplateName, singleTemplate.html());
}).name;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./src/module.js
 **/